import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../Classes';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";

const VideoPlayIcon = ({ onClick }) => (
    <div data-testId="video-play-icon" onClick={onClick} className={Classes.productVideoIconContainer}>
        <svg className={Classes.productVideoCircleIconContainer}>
            <circle className={Classes.productVideoCircleIcon}/>
        </svg>
        <FontAwesomeIcon icon={faPlay} className={Classes.productVideoPlayIcon}/>
    </div>
);

VideoPlayIcon.propTypes = {onClick: PropTypes.func};

export default VideoPlayIcon;
